module.exports = __webpack_public_path__ + "static/auto-icon-200x200-c632dffc4da8746079a114247eedc25d.png";